import { Injectable } from '@angular/core';
import { API } from 'aws-amplify';

@Injectable({
  providedIn: 'root'
})
export class GetfridgeService {
  constructor() { 

  }

  public array_fridge:Fridges[]=[];

  public async getFridge(espid: string, timeini: number, timefin: number){
    //Cargamos la apirest de Amplify
    const response = await this.getData(espid, timeini, timefin);
    return response.data.Items; // Valor que devolvemos
  }


  getData(espid: string, timeini: number, timefin: number) { 
    const apiName = 'PharaonAmicareFridgeApi';
    const path = '/fridge';
    const myInit = { // OPTIONAL
      headers: {     
        'Content-Type': 'application/json'
      }, // OPTIONAL
      response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
      queryStringParameters: {  // OPTIONAL
        espid: espid,
        timeini: timeini,
        timefin: timefin,
      },
  };

    return API.get(apiName, path, myInit);

  }
  

}

export interface Fridges{
  espid : string;
  timestamp: number;
  pir: string;
  frigo: string;

}